import React, { ReactNode, ReactElement, memo } from "react";

// components
import CommonUIWrapper from "@payment-client/components/common-ui-wrapper/CommonUIWrapper";
import CommonHeaderContent from "@payment-client/components/common-header-content/CommonHeaderContent";

// styles
import styles from "./styles.scss";

// defs
import { ConfirmPennyTransactionResponse, CreatePennyTransactionResponse } from "@swiggy-private/payment-types";

// helpers
import { getPaymentHeaderSubtitleForSubRoutesV4 } from "@payment-client/helpers/PaymentHelper";
import { CheckoutRoute, useCustomHardwareBack } from "@swiggy-private/checkout-core";

interface PennyTxnStatusPollerWrapperProps {
    children: ReactNode;
    onBack: VoidFunction;
    transaction: CreatePennyTransactionResponse | ConfirmPennyTransactionResponse;
}

function PennyTxnStatusPollerWrapper({
    children,
    onBack,
    transaction,
}: PennyTxnStatusPollerWrapperProps): ReactElement {
    useCustomHardwareBack([CheckoutRoute.PENNY_TXN_STATUS_POLLER], onBack);

    const header = (
        <CommonHeaderContent
            title={"PAYMENT DETAILS"}
            subtitle={getPaymentHeaderSubtitleForSubRoutesV4({ cartAmount: String(transaction.amount) })}
            grayscale
        />
    );

    return <CommonUIWrapper content={children} onBack={onBack} containerCSSClass={styles.container} header={header} />;
}

export default memo(PennyTxnStatusPollerWrapper);
